module.exports = __webpack_public_path__ + "img/search-back.cc671ee3.svg";